<template>
  <form @submit.prevent="saveForm()">
    <div class="" style="width: auto">
      <section class="">
        <div class="flex items-center py-12 ">
          <div class="w-2/12">
            <d-avatar :text="fullName" :img-src="thumbnailUrl" class="px-4" size="100px" />
          </div>
          <div class="w-10/12 text-left">
            <input ref="imageUpload" type="file" style="display: none" @change="uploadImage">
            <p class="mb-4">
              Select an image file on your computer (2.5MB max)
            </p>
            <d-button key="browse" :loading="uploadingFile" @click="$refs.imageUpload.click()">
              Choose Image
            </d-button>
          </div>
        </div>

        <div class="flex flex-wrap -mx-5">
          <d-field label="First Name*" class="w-full md:w-1/2 px-5">
            <d-input v-model="userForm.firstName" required />
          </d-field>
          <d-field label="Last Name*" class="w-full md:w-1/2 px-5">
            <d-input v-model="userForm.lastName" required />
          </d-field>
          <d-field label="System Email*" class="w-full md:w-1/2 px-5">
            <d-input v-model="userForm.systemEmail" type="email" required />
          </d-field>
          <d-field label="School Email" class="w-full md:w-1/2 px-5">
            <d-input v-model="userForm.schoolEmail" type="email" />
          </d-field>
          <d-field label="Personal Email" class="w-full md:w-1/2 px-5">
            <d-input v-model="userForm.personalEmail" type="email" />
          </d-field>
          <d-field label="Summer Email" class="w-full md:w-1/2 px-5">
            <d-input v-model="userForm.summerEmail" type="email" />
          </d-field>
          <d-field label="School Phone" class="w-full md:w-1/2 px-5">
            <d-input v-model="userForm.schoolPhone" />
          </d-field>
          <d-field label="Alt Phone" class="w-full md:w-1/2 px-5">
            <d-input v-model="userForm.altPhone" />
          </d-field>
          <d-field label="Contact Preference" class="w-full md:w-1/2 px-5">
            <d-select v-model="userForm.contactPreference" expanded>
              <option value="School Email">
                School Email
              </option>
              <option value="Summer Email">
                Summer Email
              </option>
              <option value="Personal Email">
                Personal Email
              </option>
            </d-select>
          </d-field>
          <d-field label="Bio" class="w-full md:w-1/2 px-5">
            <d-input v-model="userForm.bio" type="textarea" />
          </d-field>
          <d-field label="Admin Notes" class="w-full md:w-1/2 px-5">
            <d-input v-model="userForm.notes" type="textarea" />
          </d-field>
          <d-field label="Withdrawn" class="w-full md:w-1/6 px-5">
            <d-switch v-model="userForm.withdrawn" />
          </d-field>
          <d-field label="Withdrawal Date" class="w-full md:w-1/3 px-5">
            <d-datepicker v-model="userForm.withdrawalDate" />
          </d-field>
          <d-field label="Withdrawal Reason" class="w-full md:w-1/2 px-5">
            <d-input v-model="userForm.withdrawalReason" type="textarea" />
          </d-field>
        </div>
      </section>
    </div>
    <div class="mb-5 mt-5 cursor-pointer">
      <div class="flex flex-row" @click="expandFlexFields = !expandFlexFields">
        <d-icon icon="chevron-up" class="expand-icon cursor-pointer  px-3 transform" :class="{'rotate-180': expandFlexFields}" />
        <div class=" font-bold">
          Flex Fields
        </div>
      </div>
      <transition>
        <div v-if="expandFlexFields">
          <div class="flex items-center mt-5">
            <div class="w-1/2 px-2">
              <d-field :label="getFlexFieldLabelValue('Flex1')">
                <d-input v-model="userForm.flex1" />
              </d-field>
            </div>
            <div class="w-1/2 px-2">
              <d-field :label="getFlexFieldLabelValue('Flex2')">
                <d-input v-model="userForm.flex2" />
              </d-field>
            </div>
          </div>
          <div class="flex items-center">
            <div class="w-1/2 px-2">
              <d-field :label="getFlexFieldLabelValue('Flex3')">
                <d-input v-model="userForm.flex3" />
              </d-field>
            </div>
            <div class="w-1/2 px-2">
              <d-field :label="getFlexFieldLabelValue('Flex4')">
                <d-input v-model="userForm.flex4" />
              </d-field>
            </div>
          </div>
          <div class="flex items-center">
            <div class="w-1/2 px-2">
              <d-field :label="getFlexFieldLabelValue('Flex5')">
                <d-input v-model="userForm.flex5" />
              </d-field>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="flex justify-end pt-5 w-full">
      <d-btn type="submit" :loading="saving">
        Save Changes
      </d-btn>
    </div>
  </form>
</template>

<script>
  import axios from 'axios';

  export default {
    parent: true,
    props: {
      userId: {
        type: String,
        default: () => '',
      },
      canEditUser: {
        type: Boolean,
        default: () => false,
      },
    },
    data: () => ({
      saving: false,
      expandFlexFields: false,
      uploadingFile: false,
      flexFields: [],
      userForm: {
        id: '',
        firstName: '',
        lastName: '',
        systemEmail: '',
        personalEmail: '',
        summerEmail: '',
        schoolEmail: '',
        schoolPhone: '',
        altPhone: '',
        contactPreference: '',
        bestTimeToContact: '',
        bio: '',
        notes: '',
        flex1: '',
        flex2: '',
        flex3: '',
        flex4: '',
        flex5: '',
        withdrawn: false,
        withdrawalDate: null,
        withdrawalReason: '',
      },
    }),
    computed: {
      fullName() {
        return `${this.userForm.firstName} ${this.userForm.lastName}`;
      },

      thumbnailUrl() {
        return this.userForm.profileImageUrl ? `${this.userForm.profileImageUrl}?${new Date().getTime()}` : '';
      },
    },

    watch: {
      'userForm.withdrawn': function (val) {
        if (val === false) {
          this.userForm.withdrawalDate = null;
          this.userForm.withdrawalReason = '';
        }
      },
    },

    mounted() {
      this.getProfileData();
      this.getFlexFieldLabels();
    },

    methods: {
      async getProfileData() {
        const { data } = await axios.get(`/api/profile/${this.userId}`);
        this.userForm = data;
      },

      async getFlexFieldLabels() {
        const { data } = await axios.get('/api/flex-fields/user');
        this.flexFields = data;
      },

      getFlexFieldLabelValue(field) {
        const flexFieldLabel = this.flexFields.find((m) => m.field === field);
        if (flexFieldLabel) {
          return flexFieldLabel.label;
        }
        return field;
      },

      success() {
        this.$toast.open({
          message: 'Profile updated successfully!',
          position: 'bottom',
          color: 'green-500',
        });
      },

      async uploadImage() {
        this.uploadingFile = true;
        const file = this.$refs.imageUpload.files[0];
        const form = new FormData();
        form.append('File', file);
        try {
          const { data } = await axios.put(`/api/profile/${this.userId}/image`, form, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
          this.form.profileImageUrl = data;
          this.$toast.open({
            message: 'Image was successfully uploaded',
            color: 'success',
          });
        } catch (error) {
          this.$toast.open({
            duration: 5000,
            message: error.response,
            color: 'error',
          });
        } finally {
          this.resetFileInput();
          this.uploadingFile = false;
        }
      },

      async saveForm() {
        this.saving = true;
        try {
          await axios.patch(`/api/profile/${this.userId}`, this.userForm);
          this.success();
        } catch (error) {
          this.$toast.error(error.response.data[0]);
        } finally {
          this.saving = false;
        }
      },

      resetFileInput() {
        this.$refs.imageUpload.type = 'text';
        this.$refs.imageUpload.type = 'file';
        this.$refs.imageUpload.value = '';
      },
    },

  };
</script>